const id_sales_recap = {
    "": "rekap tagihan penjualan",
    add: "tambah rekap tagihan penjualan",
    detail: "detail rekap tagihan penjualan",

    label: {
        no_recap: "no rekap tagihan",
        inv_choose: "pilih invoice",
        inv_selected: "tagihan terpilih:",
    },

    error: {
        create: "Gagal membuat rekap tagihan penjualan.",
        edit: "Gagal mengubah rekap tagihan penjualan.",
    },

    success: {
        create: "Berhasil membuat rekap tagihan penjualan.",
        edit: "Berhasil mengubah rekap tagihan penjualan.",
    },
}

export default id_sales_recap;